// extracted by mini-css-extract-plugin
module.exports = {"block":"EdithContainer_block__hxlPw","wrapper":"EdithContainer_wrapper__QsxIQ","lazyLoadPlaceholder":"EdithContainer_lazyLoadPlaceholder__toGZu"};